import { get } from 'lodash';

import { getTranslatedString } from '@skinsoft/ui';

import { Alias } from './alias-data-store';

export const translatedTitle = (alias: Alias) => get(alias, 'translatedTitle');
export const lastName = (alias: Alias, locale: string) => getTranslatedString(get(alias, 'aliasSchema.lastName'), locale);
export const firstName = (alias: Alias, locale: string) => getTranslatedString(get(alias, 'aliasSchema.firstName'), locale);
export const linkedAuthority = (alias: Alias) => get(alias, 'linkAuthority');
